import Enums from "../../enums/enums";
import userInfo from "../../function/userInfo";
import { GetBankAccountListFromCache, GetProductListMapFromCache } from "../../helper/cacheHelper";
import i18n from "../../locales/i18n";
import * as api from "../../service/ApiSevice";
import assetFacade from "../../service/asset/assetFacade";
import journalFacade from "../../service/journal/journalHelper";
import transactionFacade from "../../service/transaction/transactionHelper";
import store from "../baseController";
export const actions = {
  DoGetUnseenNotificationCount({ state, commit }, merchantId) {
    api.NotificationService.DoGetUnseenNotificationCount(merchantId).then(async (res) => {
      if (res.status.IsSuccess()) {
        await commit("MutationGetNotificationCount", {
          merchantId: merchantId,
          notificationCount: res.data.notificationCount,
        });
      }
    });
  },
  DoGetUnSeenNotificationList({ state, commit }, merchantId) {
    api.NotificationService.DoGetUnseenNotificationList(merchantId).then(async (res) => {
      if (res.status.IsSuccess()) {
        const unreadNotificationList = [...res.data.notificationList];
        const input = {
          merchantId: merchantId,
          unreadNotificationList: unreadNotificationList,
        };
        await commit("MutationGetUnSeenNotificationList", input);
      }
    });
  },
  DoGetIsSeenNotificationList({ state, commit }, merchantId) {
    api.NotificationService.DoGetSeenNotificationList(merchantId).then(async (res) => {
      if (res.status.IsSuccess()) {
        const readNotificationList = [...res.data.notificationList];
        const input = {
          merchantId: merchantId,
          readNotificationList: readNotificationList,
        };
        await commit("MutationGetIsSeenNotificationList", input);
      }
    });
  },
  async DoGetAllNotificationList({ state, commit }, merchantId) {
    const seenList = await api.NotificationService.DoGetSeenNotificationList(merchantId).then(async (res) => {
      if (res.status.IsSuccess()) {
        const readNotificationList = [...res.data.notificationList];
        return {
          merchantId: merchantId,
          readNotificationList: readNotificationList,
        };
      } else {
        return null;
      }
    });
    const unseenList = await api.NotificationService.DoGetUnseenNotificationList(merchantId).then(async (res) => {
      if (res.status.IsSuccess()) {
        const unreadNotificationList = [...res.data.notificationList];
        return {
          merchantId: merchantId,
          unreadNotificationList: unreadNotificationList,
        };
      } else {
        return null;
      }
    });
    await commit("MutationGetAllNotificationList", {
      merchantId,
      readNotificationList: seenList.readNotificationList,
      unreadNotificationList: unseenList.unreadNotificationList,
    });
  },
  DoDeleteUnseenNotification({ state, commit }, input) {
    api.NotificationService.DoDeleteUnseenNotification(input.merchantId, input.notificationId).then(async (res) => {
      if (!res.status.IsSuccess()) {
        store.dispatch("SetAlertMessage", {
          alertMessage: i18n.t("Something_Wrong"),
          typeMessage: Enums.TypeComponentNoti.error,
        });
      }
    });
  },
  DoDeleteSeenNotification({ state, commit }, input) {
    api.NotificationService.DoDeleteSeenNotification(input.merchantId, input.notificationId).then(async (res) => {
      if (!res.status.IsSuccess()) {
        store.dispatch("SetAlertMessage", {
          alertMessage: i18n.t("Something_Wrong"),
          typeMessage: Enums.TypeComponentNoti.error,
        });
      }
    });
  },
  DoSetAllNotificationIsSeen({ state, commit }, merchantId) {
    return new Promise((resolve) => {
      api.NotificationService.DoSetAllNotificationIsSeen(merchantId).then(async (res) => {
        if (!res.status.IsSuccess()) {
          store.dispatch("SetAlertMessage", {
            alertMessage: i18n.t("Something_Wrong"),
            typeMessage: Enums.TypeComponentNoti.error,
          });
        } else {
          resolve(true);
        }
      });
    });
  },
  DoSetNotificationIsSeen({ state, commit }, input) {
    return new Promise((resolve) => {
      api.NotificationService.DoSetNotificationIsSeen(input.merchantId, input.notificationId).then(async (res) => {
        if (!res.status.IsSuccess()) {
          store.dispatch("SetAlertMessage", {
            alertMessage: i18n.t("Something_Wrong"),
            typeMessage: Enums.TypeComponentNoti.error,
          });
        } else {
          resolve(true);
        }
      });
    });
  },
  DoGetTransactionViewDetailForDisplay({ commit, state }, input) {
    return new Promise(async (resolve) => {
      const transactionIdList = [...new Set(input.transactionIdList)];
      const transactionType = input.transactionType;
      let transactionIdForSearch = [];

      if (state.transactionTypeListForMap && state.transactionTypeListForMap.size > 0) {
        transactionIdList.forEach((transactionId) => {
          const transactionTypeOnLocal = state.transactionTypeListForMap.get(transactionType);
          if (transactionTypeOnLocal) {
            const transactionCodeOnLocal = transactionTypeOnLocal.get(transactionId);
            if (!transactionCodeOnLocal) {
              transactionIdForSearch.push(transactionId);
            }
          } else {
            transactionIdForSearch.push(transactionId);
          }
        });
      } else {
        transactionIdForSearch = transactionIdList;
      }

      if (transactionIdForSearch.length > 0) {
        let res;
        switch (transactionType) {
          case Enums.TransactionType.Quotation:
            res = await api.TransactionService.DoGetQuotationViewDetailList(transactionIdForSearch);
            break;
          case Enums.TransactionType.Invoice:
            res = await api.TransactionService.DoGetInvoiceViewDetailList(transactionIdForSearch);
            break;
          case Enums.TransactionType.Receipt:
            res = await api.TransactionService.DoGetReceiptViewDetailList(transactionIdForSearch);
            break;
          case Enums.TransactionType.TaxInvoice:
            res = await api.TransactionService.DoGetTaxInvoiceViewDetailList(transactionIdForSearch);
            break;
          case Enums.TransactionType.CreditNote:
            res = await api.TransactionService.DoGetCreditNoteViewDetailList(transactionIdForSearch);
            break;
          case Enums.TransactionType.BillingNote:
            res = await api.TransactionService.DoGetBillingNoteViewDetailList(transactionIdForSearch);
            break;
          case Enums.TransactionType.DebitNote:
            res = await api.TransactionService.DoGetDebitNoteViewDetailList(transactionIdForSearch);
            break;
          case Enums.TransactionType.Deposit:
            res = await api.TransactionService.DoGetDepositViewDetailList(transactionIdForSearch);
            break;
          case Enums.TransactionType.GoodsReceipt:
            res = await api.TransactionService.DoGetGoodsReceiptViewDetailList(transactionIdForSearch);
            break;
          case Enums.TransactionType.InvoiceReceipt:
            res = await api.TransactionService.DoGetInvoiceReceiptViewDetailList(transactionIdForSearch);
            break;
          case Enums.TransactionType.PurchaseRequisition:
            res = await api.TransactionService.DoGetPurchaseRequisitionViewDetailList(transactionIdForSearch);
            break;
          case Enums.TransactionType.Dailyjournal:
            res = await api.TransactionService.DoGetDailyJournalViewDetailList(transactionIdForSearch);
            break;
        }
        if (res && res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          const transactionNumberList = transactionFacade.GetTransactionViewDetailList(res.data.list);
          commit("MutationSetTransactionTypeListForMap", { transactionNumberList, transactionType });
        }
        setTimeout(() => {
          resolve(state.transactionTypeListForMap);
        }, 0);
      } else {
        setTimeout(() => {
          resolve(state.transactionTypeListForMap);
        }, 0);
      }
    });
  },
  DoGetJournalViewDetailForDisplay({ commit, state }, input) {
    return new Promise(async (resolve) => {
      const journalIdList = [...new Set(input.journalIdList)];
      let journalIdForSearch = [];

      if (state.journalViewDetailListForMap && state.journalViewDetailListForMap.size > 0) {
        journalIdList.forEach((journalId) => {
          const journalOnLocal = state.journalViewDetailListForMap.get(journalId);
          if (!journalOnLocal) {
            journalIdForSearch.push(journalId);
          }
        });
      } else {
        journalIdForSearch = journalIdList;
      }

      if (journalIdForSearch.length > 0) {
        const res = await api.JournalService.DoGetJournalViewDetailList(journalIdForSearch);

        if (res && res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          const journalViewDetailList = journalFacade.GetJournalViewDetailList(res.data.list);
          commit("MutationSetJournalViewDetailListForMap", journalViewDetailList);
        }
        setTimeout(() => {
          resolve(state.journalViewDetailListForMap);
        }, 0);
      } else {
        setTimeout(() => {
          resolve(state.journalViewDetailListForMap);
        }, 0);
      }
    });
  },
  DoGetPaymentTransferViewDetailForDisplay({ commit, state }, input) {
    return new Promise(async (resolve) => {
      const paymentGroupIdList = [...new Set(input.paymentGroupIdList)];
      const bankAccountId = input.bankAccountId;
      let paymentGroupIdForSearch = [];

      if (state.paymentTransferViewDetailListForMap && state.paymentTransferViewDetailListForMap.size > 0) {
        paymentGroupIdList.forEach((paymentGroupId) => {
          const transactionTypeOnLocal = state.paymentTransferViewDetailListForMap.get(paymentGroupId);
          if (!transactionTypeOnLocal) {
            paymentGroupIdForSearch.push(paymentGroupId);
          }
        });
      } else {
        paymentGroupIdForSearch = paymentGroupIdList;
      }

      if (paymentGroupIdForSearch.length > 0) {
        let res = await api.TransactionService.DoGetPaymentTransferViewDetailList(
          bankAccountId,
          paymentGroupIdForSearch
        );
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          const paymentTransferViewDetailList = transactionFacade.GetPaymentTransferViewDetailList(res.data.list);
          commit("MutationSetPaymentTransferViewDetailListForMap", paymentTransferViewDetailList);
        }
        setTimeout(() => {
          resolve(state.paymentTransferViewDetailListForMap);
        }, 0);
      } else {
        setTimeout(() => {
          resolve(state.paymentTransferViewDetailListForMap);
        }, 0);
      }
    });
  },
  DoGetChequeViewDetailForDisplay({ commit, state }, chequeIdList) {
    return new Promise(async (resolve) => {
      let chequeIdForSearch = [];

      if (state.chequeViewDetailListForMap && state.chequeViewDetailListForMap.size > 0) {
        chequeIdList.forEach((chequeId) => {
          const transactionTypeOnLocal = state.chequeViewDetailListForMap.get(chequeId);
          if (!transactionTypeOnLocal) {
            chequeIdForSearch.push(chequeId);
          }
        });
      } else {
        chequeIdForSearch = chequeIdList;
      }

      if (chequeIdForSearch.length > 0) {
        let res = await api.TransactionService.DoGetChequeViewDetailList(chequeIdForSearch);
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          const chequeViewDetailList = transactionFacade.GetChequeViewDetailList(res.data.list);
          commit("MutationSetChequeViewDetailListForMap", chequeViewDetailList);
        }
        setTimeout(() => {
          resolve(state.chequeViewDetailListForMap);
        }, 0);
      } else {
        setTimeout(() => {
          resolve(state.chequeViewDetailListForMap);
        }, 0);
      }
    });
  },
  DoGetProductCodeForDisplay({ commit, state }, _productIdList) {
    return new Promise(async (resolve) => {
      const productIdList = [...new Set(_productIdList)];
      let productIdListForSearchCache = [];
      let productIdListForSearchAPI = [];

      if (state.productCodeListForMap && state.productCodeListForMap.size > 0) {
        productIdList.forEach((productId) => {
          const productTemplateCodeOnLocal = state.productCodeListForMap.get(productId);
          if (!productTemplateCodeOnLocal) {
            productIdListForSearchCache.push(productId);
          }
        });
      } else {
        productIdListForSearchCache = [...productIdList];
      }

      if (productIdListForSearchCache.length > 0) {
        const productListCacheMap = await GetProductListMapFromCache(userInfo.MerchantId());
        if (productListCacheMap && productListCacheMap.size > 0) {
          productIdListForSearchCache.forEach((productId) => {
            const productTemplateCodeOnCache = productListCacheMap.get(productId);
            if (productTemplateCodeOnCache) {
              commit("MutationSetProductCodeListForMap", [productTemplateCodeOnCache]);
            } else {
              productIdListForSearchAPI.push(productId);
            }
          });
        } else {
          productIdListForSearchAPI = [...productIdListForSearchCache];
        }
      }

      if (productIdListForSearchAPI.length > 0) {
        const productList = await store.dispatch("DoGetProductTemplateCacheById", productIdListForSearchAPI);
        commit("MutationSetProductCodeListForMap", productList);
      }

      setTimeout(() => {
        resolve(state.productCodeListForMap);
      }, 0);
    });
  },
  DoGetBankAccountCodeForDisplay({ commit, state }, _bankAccountIdList) {
    return new Promise(async (resolve) => {
      const bankAccountIdList = [...new Set(_bankAccountIdList)];
      let bankAccountIdListForSearchCache = [];
      let bankAccountIdListForSearchAPI = [];

      if (state.bankAccountIdListForMap && state.bankAccountIdListForMap.size > 0) {
        bankAccountIdList.forEach((bankId) => {
          const bankAccountOnLocal = state.bankAccountIdListForMap.get(bankId);
          if (!bankAccountOnLocal) {
            bankAccountIdListForSearchCache.push(bankId);
          }
        });
      } else {
        bankAccountIdListForSearchCache = [...bankAccountIdList];
      }

      if (bankAccountIdListForSearchCache.length > 0) {
        const bankAccountListCacheMap = await GetBankAccountListFromCache(userInfo.MerchantId());
        if (bankAccountListCacheMap && bankAccountListCacheMap.size > 0) {
          bankAccountIdListForSearchCache.forEach((bankId) => {
            const bankAccountCodeOnCache = bankAccountListCacheMap.get(bankId);
            if (bankAccountCodeOnCache) {
              commit("MutationSetBankAccountListForMap", [bankAccountCodeOnCache]);
            } else {
              bankAccountIdListForSearchAPI.push(bankId);
            }
          });
        } else {
          bankAccountIdListForSearchAPI = [...bankAccountIdListForSearchCache];
        }
      }

      if (bankAccountIdListForSearchAPI.length > 0) {
        const bankAccountList = await store.dispatch("DoGetBankAccountCacheById", bankAccountIdListForSearchAPI);
        commit("MutationSetBankAccountListForMap", bankAccountList);
      }

      setTimeout(() => {
        resolve(state.bankAccountIdListForMap);
      }, 0);
    });
  },
  DoGetAssetTemplateCodeForDisplay({ commit, state }, _assetTemplateIdList) {
    return new Promise((resolve) => {
      const assetTemplateIdList = [...new Set(_assetTemplateIdList)];

      let assetTemplateIdListForSearch = [];

      if (state.assetTemplateCodeListForMap && state.assetTemplateCodeListForMap.size > 0) {
        assetTemplateIdList.forEach((assetTemplateId) => {
          const assetTemplateCodeOnLocal = state.assetTemplateCodeListForMap.get(assetTemplateId);
          if (!assetTemplateCodeOnLocal) {
            assetTemplateIdListForSearch.push(assetTemplateId);
          }
        });
      } else {
        assetTemplateIdListForSearch = assetTemplateIdList;
      }

      if (assetTemplateIdListForSearch.length > 0) {
        api.AssetService.DoGetAssetTemplateCodeByAssetTemplateIdList(assetTemplateIdListForSearch).then((res) => {
          if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
            const assetTemplateCodeList = assetFacade.ConvertToAssetTemplateCodeList(res.data.assetTemplateCodeList);
            commit("MutationSetAssetTemplateCodeListForMap", assetTemplateCodeList);
            resolve(state.assetTemplateCodeListForMap);
          } else {
            resolve(null);
          }
        });
      } else {
        setTimeout(() => {
          resolve(state.assetTemplateCodeListForMap);
        }, 0);
      }
    });
  },
};
